import { useMemo } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { useMenuAccess } from '../../../context/MenuAccessContext';
import { useProgressiveNavContext } from '../../../hooks/useProgressiveNavContext';
import { useProgressiveMenuAccess } from './progressiveNav';
import {
  buildAdministrationLandingModules,
  hasAdministrationDesktopAccess,
} from './adminNavConfig';

/**
 * Shared access context for Administration landing and route guard.
 */
export function useAdministrationAccess() {
  const { user } = useAuth();
  const { hasMenuAccess: baseHasMenuAccess, hasMenuAccessOrChild: baseHasMenuAccessOrChild, menusLoaded } = useMenuAccess();
  const { isDemoProjectBootstrap } = useProgressiveNavContext();
  const {
    showCompanyMenu,
    hasMenuAccess,
    hasMenuAccessOrChild,
  } = useProgressiveMenuAccess({
    isDemoProjectBootstrap,
    hasMenuAccess: baseHasMenuAccess,
    hasMenuAccessOrChild: baseHasMenuAccessOrChild,
  });

  const isAdmin = user?.role === 'admin' || user?.role === 'superadmin';

  return useMemo(() => {
    const accessCtx = {
      showCompanyMenu,
      isAdmin,
      hasMenuAccess,
      hasMenuAccessOrChild,
    };
    const canAccess = menusLoaded && hasAdministrationDesktopAccess(accessCtx);
    const modules = canAccess ? buildAdministrationLandingModules(accessCtx) : [];

    return {
      menusLoaded,
      canAccess,
      modules,
      accessCtx,
      isAdmin,
    };
  }, [
    showCompanyMenu,
    isAdmin,
    hasMenuAccess,
    hasMenuAccessOrChild,
    menusLoaded,
  ]);
}

export default useAdministrationAccess;
